/*
 * @Author: mayanxia 
 * @Date: 2020-08-28 21:49:25 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2024-02-05 16:35:10
 */
 <style scoped lang="less" scoped>
 #binsess-center-contain{
   background: url('~@/assets/images/waterPay/base.png') #071737 no-repeat;
   background-position: center center;
   //background-size: 100% 100%;
   display: flex;
   color: #fff;
   height: 98%;
   width: 908px;
   align-items: end;
   margin-bottom: 10px;
   position: relative;
 }
 .item-center{
  position: absolute;
  z-index: 2;
  left: 50%;
  //bottom: 50%;
  width: 340px;
  height: 251px;
  transform: translateX(-50%);
  background: url('~@/assets/images/waterPay/center-underside.png') no-repeat;
 }
 .item-center-between{
  position: absolute;
  z-index: 3;
  left: 50%;
  bottom: 70px;
  width: 293px;
  height: 210px;
  transform: translatex(-50%);
  background: url('~@/assets/images/waterPay/center-between.png') no-repeat;
 }
 .item-center-between-light{
  position: absolute;
  z-index: 3;
  left: 50%;
  bottom: 125px;
  width: 226px;
  height: 131px;
  transform: translatex(-50%);
  background: url('~@/assets/images/waterPay/center-between-light.png') no-repeat;
  animation: hovertriangle 0.5s infinite;
 }
  .item-center-top{
  position: absolute;
  z-index: 4;
  left: 50%;
  bottom: 140px;
  width: 259px;
  height: 192px;
  transform: translateX(-50%);
  background: url('~@/assets/images/waterPay/center-top.png') no-repeat;
 }
 .item-center-pre-light{
    position: absolute;
    z-index: 6;
    left: 50%;
    bottom: 180px;
    width: 259px;
    height: 357px;
    transform: translateX(-50%);
    background: url('~@/assets/images/waterPay/pre-light.png') no-repeat;
 }
  .item-center-aft-light{
    position: absolute;
    z-index: 5;
    left: 50%;
    bottom: 280px;
    width: 182px;
    height: 135px;
    transform: translateX(-50%);
    background: url('~@/assets/images/waterPay/aft-light.png') no-repeat;
 }
   .item-center-square{
    position: absolute;
    z-index: 7;
    left: 50%;
    bottom: 300px;
    width: 181px;
    height: 217px;
    transform: translateX(-50%);
    background: url('~@/assets/images/waterPay/center-square.png') no-repeat;
    animation: hoverMove 0.4s infinite;
 }
 .item-top-left{
    position: absolute;
    z-index: 7;
    left: 0px;
    bottom: 240px;
    width: 247px;
    height: 305px;
    //transform: translateX(-50%);
    background: url('~@/assets/images/waterPay/top-left.png') no-repeat;
 }
  .item-top-right{
    position: absolute;
    z-index: 7;
    right: 0px;
    bottom: 240px;
    width: 247px;
    height: 305px;
    //transform: translateX(-50%);
    background: url('~@/assets/images/waterPay/top-right.png') no-repeat;
 }
   .item-bottom-left{
    position: absolute;
    z-index: 7;
    left: 0px;
    bottom: -20px;
    width: 247px;
    height: 305px;
    //transform: translateX(-50%);
    background: url('~@/assets/images/waterPay/bottom-left.png') no-repeat;
    
 }
   .item-bottom-right{
    position: absolute;
    z-index: 7;
    right: 0px;
    bottom: -20px;
    width: 247px;
    height: 305px;
    //transform: translateX(-50%);
    background: url('~@/assets/images/waterPay/bottom-right.png') no-repeat;
 }
 .item {
    align-items: end;
    justify-content: center;
  }
  .item p {
    color: #8ADAFF;
    font-size: 18px;
  }
  @keyframes hovertriangle {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
}
  @keyframes hoverMove {
    0% {
      transform: translate(-50%,0);
    }
    50% {
      transform: translate(-50%,10px);
    }
    100% {
        transform: translateY(-50%,0);
    }
}
</style>
<template>
  <div class="flex flex-center" style="height: 100%;width: 100%;align-items:end">
    <div id="binsess-center-contain">
      <div class="item item-top-left flex" style="">
        <p>{{ $t('营业缴费') }}</p>
      </div>
      <div class="item item-top-right flex" style="">
        <p>{{ $t('故障报修') }}</p>
      </div>
      <div class="item item-bottom-left flex" style="">
        <p>{{ $t('用水统计') }}</p>
      </div>
      <div class="item item-bottom-right flex" style="">
        <p>{{ $t('设备检测') }}</p>
      </div>
      <div class="item-center" style="">
        <div class="item-center-between" style="">
        
        </div>
        <div class="item-center-between-light" style="">
        
        </div>
        <div class="item-center-top" style="">
        
        </div>
        <div class="item-center-pre-light" style="">
        
        </div>
        <div class="item-center-aft-light" style="">
        
        </div>
        <div class="item-center-square" style="">
        
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import animatedInteger from '@/components/maComponents/animated-integer';
import { putAction } from '@/api/manage';
import {isNull} from '@/utils/validate'
export default {
  components: {
    animatedInteger
  },
  data() {
    return {
      color: '#5B87C3',
      valueColor: '#00FAFE',
      unitColor: '#6ED9F2',
      url: {
        payMoneyCount: '/jeecg-charge/meter/waterAnalysis/payMoneyCount',
        waterUse: '/jeecg-charge/meter/waterAnalysis/waterUse'
      },
    }
  },
  methods: {
    init() {
      console.log("lalalalla ")
    }
  }
}
</script>
